import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Toaster } from 'react-hot-toast';
import App from './App.tsx';
import { AppProvider } from './context/AppContext';
import { AdminProvider } from './admin/context/AdminContext';
import './index.css';

// Service Worker Registration
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(registration => {
        console.log('Service Worker registered: ', registration);
      })
      .catch(error => {
        console.error('Service Worker registration failed: ', error);
      });
  });

  // Listen for cache update messages from service worker
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data && event.data.type === 'CACHE_UPDATED') {
      console.log(`%c🚀 ${event.data.message}`, 'color: #10b981; font-weight: bold;');
      
      // Show a notification to the user
      if (window.confirm(`${event.data.message}\n\nWould you like to refresh now to get the latest features?`)) {
        window.location.reload();
      }
    }
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppProvider>
      <AdminProvider>
        <App />
        <Toaster position="top-right" />
      </AdminProvider>
    </AppProvider>
  </StrictMode>
);